import React from "react";
import { CNYProps } from "../../../../../types/walletTypes";
import { useAppSelector } from "../../../../../app/hooks";
import { CountryConfig } from "../types";

interface SenderProps extends CNYProps {
  config: CountryConfig;
}

const Sender = ({ handleNext, handlePrevious, config }: SenderProps) => {
  const countryKey = (config.dataSliceKey || config.code).toLowerCase();
  const asiaPayoutData = useAppSelector((state) => (state.formData as any)?.asiaPayoutData);
  const getSavedData = asiaPayoutData?.[countryKey] || {};

  const paymentMethod = getSavedData?.paymentMethod;

  const CurrentStepComponent =
    (config.formRegistry.sender?.[paymentMethod] as any) ||
    (config.formRegistry.sender?.default as any);

  if (!CurrentStepComponent) return null;

  return (
    <CurrentStepComponent
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      config={config}
    />
  );
};

export default Sender;
